export default __webpack_public_path__ + "static/media/spinner.ee9b31b9.svg";